import*as e from"react";export function usePrevious(r){const u=e.useRef({value:r,previous:r});return e.useMemo((()=>(u.current.value!==r&&(u.current.previous=u.current.value,u.current.value=r),u.current.previous)),[r])}
//# sourceMappingURL=index.module.js.map
